import { useMutation } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";

interface CreateReplaceShiftRequestParams {
	departmentId: string;
	dayNumber: number;
	shiftType: string;
	roles: string[];
	createdBy: string;
	shiftStart: string;
	shiftEnd: string;
	replacementNurseId: number;
	location?: string;
	replacementShiftId?: string;
	chargeOnly: boolean;
	bonus?: number;
	jobId?: string;
}

interface CancelReplaceShiftRequestParams {
	requestId: string;
	departmentId: string;
}

export const useCreateReplaceShiftRequest = () => {
	return useMutation({
		mutationFn: async (params: CreateReplaceShiftRequestParams) => {
			const response = await backendService.createReplaceShiftRequest(params.departmentId, {
				day_number: params.dayNumber,
				shift_type: params.shiftType,
				roles: params.roles,
				created_by: params.createdBy,
				shift_start: params.shiftStart,
				shift_end: params.shiftEnd,
				replacement_nurse_id: params.replacementNurseId,
				location: params.location,
				replacement_shift_id: params.replacementShiftId,
				charge_only: params.chargeOnly,
				bonus: params.bonus,
				job_id: params.jobId,
			});
			return response.data;
		},
	});
};

export const useCancelReplaceShiftRequest = () => {
	return useMutation({
		mutationFn: async (params: CancelReplaceShiftRequestParams) => {
			const response = await backendService.cancelReplaceShiftRequest(params.requestId, params.departmentId);
			return response.data;
		},
	});
};
